import {
    deviceType as type,
    osName,
    isDesktop,
    isMobile,
    isTablet
} from 'react-device-detect'

export const useDevice = () => {
    // console, mobile, tablet, smarttv, wearable, embedded || desktop (browser)
    const deviceType = isDesktop ? 'desktop' : type
    return { isMobile, isTablet, deviceType, osName }
}
export const getDevice = useDevice
